import { BasicDestroyGameCommand, EnvGlobalsHandler } from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { Poker2EnvironmentGlobals } from "../../Poker2EnvironmentGlobals";

export class Poker2DestroyGameCommand extends BasicDestroyGameCommand {
    public execute(commandVars: any = null): void {
        this.env.clientInstanceHash = -1;
        super.execute();
    }

    private get env(): Poker2EnvironmentGlobals {
        return <Poker2EnvironmentGlobals>EnvGlobalsHandler.globals;
    }
}
classImplementsInterfaces(Poker2DestroyGameCommand, "ISimpleCommand");
